import { Card } from "antd";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { getDateRangeTitles } from "../../helpers/dayjsSetup";

export default function ShipmentActivity({ data }) {
    const dateRangeTitles = getDateRangeTitles();
    return (
        <Card className="shadow-sm rounded-xl h-full">
            <div className="mb-4">
                <div className="text-[18px] font-semibold" title="Count of collected containers">
                    Shipment Activity
                </div>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
                <MiniStat label="Month to Date" value={data?.monthToDate} title={dateRangeTitles?.monthToDate} />
                <MiniStat label="Last Month" value={data?.lastMonth} title={dateRangeTitles?.lastMonth} />
                <MiniStat label="Last Quarter" value={data?.lastQuarter} title={dateRangeTitles?.lastQuarter} />
                <MiniStat label="Last 12 Months" value={data?.last12Months} title={dateRangeTitles?.last12Months} />
            </div>
            <div className="h-64">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={data?.monthlyData}>
                        <CartesianGrid
                            strokeDasharray="3 3"
                            vertical={false}
                            stroke="#e5e7eb"
                        />
                        <XAxis
                            dataKey="month"
                            tick={{ fontSize: 14 }}
                            axisLine={false}
                            tickLine={false}
                        />
                        <YAxis
                            tick={{ fontSize: 14 }}
                            axisLine={false}
                            tickLine={false}
                        />
                        <Tooltip />
                        <Bar
                            dataKey="count"
                            fill="#0d9488"
                            radius={[6, 6, 0, 0]}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </Card>
    );
}

function MiniStat({ label, value, title }) {
    return (
        <div className="text-center bg-gray-100 rounded-lg px-2 py-1" title={title}>
            <div className="text-[14px]">
                {label}
            </div>
            <div className="text-[16px] font-semibold">
                {value}
            </div>
        </div>
    );
}